import React from 'react';
import DirectBookingMFE from './direct-booking-mfe';
import DirectBooking from './direct-booking';

export default function DirectBookingWrapper(props) {
  const { config } = props;
  const useMfe = config?.darkship_feature_flags?.direct_book_mfe === true;
  if (useMfe) {
    return <DirectBookingMFE {...props} />;
  }
  return <DirectBooking {...props} />;
}
